// Browser page translation (Chrome's "Translate to Spanish") swaps React's
// text nodes for its own <font> wrappers. When React later removes or inserts
// next to a node the translator already moved, the DOM throws ("Failed to
// execute 'removeChild' on 'Node'") and the page falls to the error screen.
// Oct 18: 5 such crashes from Spanish-language browsers, on the listing
// wizard, listing pages and messages. The usual fix for this React issue: a
// node that is no longer where React thinks it is is left alone instead of
// throwing. Reported once per page as a client error of kind "translate".
import { reportError } from "@/lib/errorReporting";

let installed = false;

export function installTranslateGuard(proto: Node = typeof Node === "function" ? Node.prototype : (undefined as unknown as Node)): void {
  if (!proto || installed) return;
  installed = true;

  const originalRemoveChild = proto.removeChild;
  proto.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      reportError("translate", "removeChild on a node a translator moved");
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = proto.insertBefore;
  proto.insertBefore = function <T extends Node>(this: Node, node: T, ref: Node | null): T {
    if (ref && ref.parentNode !== this) {
      reportError("translate", "insertBefore next to a node a translator moved");
      return originalInsertBefore.call(this, node, null) as T;
    }
    return originalInsertBefore.call(this, node, ref) as T;
  };
}
